import {
  Checkbox,
  LoadingOverlay,
  ModalProps,
  Stack,
  TextInput,
} from "@mantine/core"
import { DefaultModal } from "../../../../-components/default-modal"
import { useForm } from "@mantine/form"

import { usePostMutation } from "../../../../typed-client/hooks/use-post-mutation"
import {
  showErrorNotification,
  showSuccessNotification,
} from "../../../../utils/form-submission-notifications"
import { FormButtonGroup } from "../../../../-components/form-button-group"
import { CancelButton, SubmitButton } from "../../../../-components/Buttons"
import { useTranslation } from "react-i18next"
import { DateOnly } from "../../../../@client/System"
import { PublishPlanLayoutAttachment } from "../../../../@client/Theasoft_ApiServer_Attachments"
import { useInvalidate } from "../../../../typed-client/hooks/use-invalidate"

interface Props extends ModalProps {
  planLayoutId: number
  startDate: DateOnly
  endDate: DateOnly
}

export function PublishPlanModal({
  planLayoutId,
  startDate,
  endDate,
  ...props
}: Props) {
  const form = useForm<PublishPlanLayoutAttachment>({
    mode: "uncontrolled",
    initialValues: {
      planLayoutId,
      publishOnDashboard: true,
      showWithoutPermission: false,
      startDate: startDate,
      endDate: endDate,
      description: "",
    },
  })

  const invalidate = useInvalidate()

  const { mutateAsync: publishPlanAsync, isPending } = usePostMutation(
    "/api/planLayout/attachments/PublishPlan",
    {
      onError: showErrorNotification,
      onSuccess: () => {
        invalidate("/api/planLayout/attachments/GetPlanLayoutAttachments")
        showSuccessNotification(t("Success"))
        form.reset()
        props.onClose?.()
      },
    }
  )

  const handleSubmitAync = async (values: PublishPlanLayoutAttachment) => {
    await publishPlanAsync(values)
  }

  const { t } = useTranslation("app_server")

  return (
    <DefaultModal title={t("PublishPlan")} {...props}>
      <form onSubmit={form.onSubmit(handleSubmitAync)}>
        <Stack>
          <TextInput
            label={t("Description")}
            key={form.key("description")}
            {...form.getInputProps("description")}
          />
          <Checkbox
            label={t("PublishOnDashboard")}
            key={form.key("publishOnDashboard")}
            {...form.getInputProps("publishOnDashboard", { type: "checkbox" })}
          />
          <Checkbox
            label={t("ShowWithoutPermission")}
            key={form.key("showWithoutPermission")}
            {...form.getInputProps("showWithoutPermission", {
              type: "checkbox",
            })}
          />
          <FormButtonGroup>
            <CancelButton onClick={props.onClose} />
            <SubmitButton>{t("Publish")}</SubmitButton>
          </FormButtonGroup>
        </Stack>
      </form>
      <LoadingOverlay visible={isPending} />
    </DefaultModal>
  )
}
